var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimensionsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 9.6875,
    width: 20.7353,
    height: 20.7353,
    rx: 2.25,
    fill: "white",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33024 3.6818C1.1545 3.85754 1.1545 4.14246 1.33024 4.3182L4.19402 7.18198C4.36976 7.35772 4.65468 7.35772 4.83042 7.18198C5.00615 7.00624 5.00615 6.72132 4.83042 6.54558L2.28483 4L4.83042 1.45442C5.00615 1.27868 5.00615 0.993756 4.83042 0.81802C4.65468 0.642284 4.36976 0.642284 4.19402 0.81802L1.33024 3.6818ZM21.7313 4.3182C21.9071 4.14246 21.9071 3.85754 21.7313 3.6818L18.8676 0.81802C18.6918 0.642284 18.4069 0.642284 18.2312 0.81802C18.0554 0.993756 18.0554 1.27868 18.2312 1.45442L20.7767 4L18.2312 6.54558C18.0554 6.72132 18.0554 7.00624 18.2312 7.18198C18.4069 7.35772 18.6918 7.35772 18.8676 7.18198L21.7313 4.3182ZM1.64844 4.45H21.4131V3.55H1.64844V4.45Z",
    fill: "#5B5E5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3182 10.2677C28.1425 10.092 27.8575 10.092 27.6818 10.2677L24.818 13.1315C24.6423 13.3073 24.6423 13.5922 24.818 13.7679C24.9938 13.9437 25.2787 13.9437 25.4544 13.7679L28 11.2223L30.5456 13.7679C30.7213 13.9437 31.0062 13.9437 31.182 13.7679C31.3577 13.5922 31.3577 13.3073 31.182 13.1315L28.3182 10.2677ZM27.6818 30.6688C27.8575 30.8446 28.1425 30.8446 28.3182 30.6688L31.182 27.8051C31.3577 27.6293 31.3577 27.3444 31.182 27.1687C31.0062 26.9929 30.7213 26.9929 30.5456 27.1687L28 29.7142L25.4544 27.1687C25.2787 26.9929 24.9938 26.9929 24.818 27.1687C24.6423 27.3444 24.6423 27.6293 24.818 27.8051L27.6818 30.6688ZM27.55 10.5859L27.55 30.3506L28.45 30.3506L28.45 10.5859L27.55 10.5859Z",
    fill: "#5B5E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensionsIcon);
export default __webpack_public_path__ + "static/media/dimensions_icon.2b9fd6f7703532adc0eb88305ba6e8ba.svg";
export { ForwardRef as ReactComponent };